import PropTypes from 'prop-types';
import { Alert, Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return searchQuery ? (
    <Alert severity="error" color="error" {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Busqueda sin resultados
      </Typography>
      <Typography variant="body2" align="center">
        No hay resultados para &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>.
      </Typography>
    </Alert>
  ) : (
    <Typography variant="body2"> Please enter keywords</Typography>
  );
}
